import online from '../assets/images/icon-online.svg';
import budgeting from '../assets/images/icon-budgeting.svg';
import onboarding from '../assets/images/icon-onboarding.svg';
import api from '../assets/images/icon-api.svg';

export const whyChooseEasybank = [
  {
    icon: online,
    title: 'Online Banking',
    text: 'Our modern web and mobile applications allow you to keep track of your finances wherever you are in the world.',
  },
  {
    icon: online,
    title: 'Simple Budgeting',
    text: 'See exactly where your money goes each month. Receive notifications when you’re close to hitting your limits.',
  },
  {
    icon: onboarding,
    title: 'Fast Onboarding',
    text: 'We don’t do branches. Open your account in minutes online and start taking control of your finances right away.',
  },
  {
    icon: api,
    title: 'Open API',
    text: 'Manage your savings, investments, pension, and much more from one account. Tracking your money has never been easier.',
  },
];
